export const WithdrawNavTitle = {
  WITHDRAW: "withdraw",
  HISTORY: "history",
};
